import { getAuthHeadersWithTokenOnly } from '@discover-frontend/auth';

import {
  getAccountsApiBaseUrl,
  TRIAL_UPGRADE_REQUEST_ENDPOINTS,
} from './constants';
import { TrialUpgradeRequestError } from './errors';

export type TrialUpgradeRequestPayload = {
  feature: string;
};

export interface TrialUpgradeRequestResponse {
  ok?: boolean;
  code?: string;
  message?: string;
  requested_at?: string;
}

export { TrialUpgradeRequestError } from './errors';

export const postTrialUpgradeRequest = async (
  body: TrialUpgradeRequestPayload
): Promise<TrialUpgradeRequestResponse> => {
  const url = `${getAccountsApiBaseUrl()}${
    TRIAL_UPGRADE_REQUEST_ENDPOINTS.UPGRADE_REQUEST
  }`;

  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...getAuthHeadersWithTokenOnly(),
  };

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  const data = (await response
    .json()
    .catch(() => ({}))) as TrialUpgradeRequestResponse;

  if (!response.ok) {
    throw new TrialUpgradeRequestError({
      code: data.code,
      message: data.message || response.statusText,
      status: response.status,
    });
  }

  if (data.ok === false) {
    throw new TrialUpgradeRequestError({
      code: data.code,
      message: data.message,
    });
  }

  return data;
};
